import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { store } from '@/store/store';
import '@/styles/index.scss';
import Loading from '@/components/elems/Loading/Loading.component';
import App from '@/App';

const root = createRoot(document.querySelector('#root')!);

root.render(
    <StrictMode>
        <Provider store={store}>
            <Suspense fallback={<Loading />}>
                <Router basename="/">
                    <App />
                </Router>
            </Suspense>
        </Provider>
    </StrictMode>,
);
